/**
 *Created by jmmartinez on 11/11/19
 * v.1.2 12/11/2019 Añadido estilo al EditableCellCadenaRenderer
 * v.1.3 08/05/2020 Añadido paramentro onKEyUP a gerEditableCellRenderer y gerEditableCellCAdenaRenderer
 * v.1.4 01/06/2020 Unificación en una únia funcion: getEditableCellRenderer
 * v.1.5 14/09/2020 En getEditableCellRenderer, en el caso CELLTIPO_COLOR, si valor es null, asignamos valor="", para evitar que
 *                      se vea la cadena de color de la página anterior.
 * v.2.0   30/09/2020 Cambiado a framework2
 **/

import React from 'react'
import {EditableCell} from "@blueprintjs/table";
import { getValor, getStyleDeNivelYPie } from "./CellRenderers";
import {CELLTIPO_CADENA, CELLTIPO_FECHA, CELLTIPO_COLOR, CELLTIPO_PORCENTAJE} from "../ej2/UI/TiposCeldas"
import {getFormattedDateFromTimestamp} from "../ej2/utils/DateUtils";




export const getEditableCellRenderer= (cellValidator, cellSetter, columnaIndex, columna, nivel, datos, resourcesImages, onKeyUp) => {

    let tipo= columna.tipo;
    let key= columna.campo;
    return (row) => {
        console.log("EDITABLE CELL RENDERER");
        let nivelValor = nivel ? datos[row][nivel.campo] : -1;
        let esPie= datos[row].esPie;
        let valor= getValor(key, row, datos);
        let style= getStyleDeNivelYPie(nivelValor, esPie,  CELLTIPO_CADENA);
        switch (tipo){
            case CELLTIPO_PORCENTAJE:
                valor= valor + " %";
                style= getStyleDeNivelYPie(nivelValor, esPie,  CELLTIPO_PORCENTAJE);
                break;
            case CELLTIPO_FECHA:
                valor= getFormattedDateFromTimestamp(valor);
                style= getStyleDeNivelYPie(nivelValor, esPie,  CELLTIPO_FECHA);
                break;
            case CELLTIPO_COLOR:
                if (!valor)
                    valor= "";
                style= getStyleDeNivelYPie(nivelValor, esPie,  CELLTIPO_COLOR);
                if (!esPie && valor)
                    style.backgroundColor= valor;
                break;
        }

        return <EditableCell
            style={style}
            value={valor}
            onChange={cellValidator(row, columnaIndex)}
            onConfirm={cellSetter(row, columnaIndex)}

            onKeyUp={ onKeyUp ? (event) => onKeyUp(event, columnaIndex, row) : null}
        />
    }

}
